import AbstractComponent from './AbstractComponent';

export default class View extends AbstractComponent {
}